class FreeShippingProgress {
  constructor() {
    this.cartUpdateUnsubscriber = null;
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    this.handleSectionLoad = this.handleSectionLoad.bind(this);

    this.init();
  }

  init() {
    this.updateAll();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate);
    }

    document.addEventListener('shopify:section:load', this.handleSectionLoad);
  }

  handleCartUpdate(event = {}) {
    this.updateAll(event.cartData?.total_price);
  }

  handleSectionLoad() {
    this.updateAll();
  }

  updateAll(cartTotalCents) {
    document.querySelectorAll('[data-free-shipping-progress]').forEach((progressElement) => {
      this.updateProgressElement(progressElement, cartTotalCents);
    });
  }

  updateProgressElement(progressElement, cartTotalCents) {
    const thresholdCents = Number(progressElement.dataset.thresholdCents) || 0;
    if (thresholdCents <= 0) return;

    const fallbackTotalCents = Number(progressElement.dataset.cartTotalCents) || 0;
    const currentTotalCents = Number.isFinite(cartTotalCents) ? cartTotalCents : fallbackTotalCents;
    const remainingCents = Math.max(thresholdCents - currentTotalCents, 0);
    const progressPercentage = Math.min((currentTotalCents / thresholdCents) * 100, 100);

    const messageElement = progressElement.querySelector('[data-free-shipping-message]');
    const progressFillElement = progressElement.querySelector('[data-free-shipping-fill]');
    const unlockedMessage = this.decodeHtmlEntities(progressElement.dataset.unlockedMessage || '');
    const remainingTemplate = this.decodeHtmlEntities(progressElement.dataset.remainingTemplate || '');

    if (messageElement) {
      if (remainingCents > 0) {
        messageElement.textContent = remainingTemplate.replace('[amount]', this.formatMoney(remainingCents, progressElement));
      } else {
        messageElement.textContent = unlockedMessage;
      }
    }

    if (progressFillElement) {
      progressFillElement.style.width = `${progressPercentage}%`;
    }

    const iconElement = progressElement.querySelector('[data-free-shipping-icon]');
    if (iconElement) {
      iconElement.classList.toggle('cart-free-shipping__end-icon--unlocked', remainingCents === 0);
    }

    progressElement.classList.toggle('cart-free-shipping--unlocked', remainingCents === 0);

    progressElement.querySelector('.cart-free-shipping__progress')?.setAttribute('aria-valuenow', Math.round(progressPercentage));
    progressElement.dataset.cartTotalCents = String(currentTotalCents);
  }

  formatMoney(cents, progressElement) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, progressElement.dataset.moneyFormat);
    }

    const currencyCode = window.Shopify?.currency?.active || 'EUR';
    const localeCode = document.documentElement.lang || undefined;
    const amount = cents / 100;

    try {
      return new Intl.NumberFormat(localeCode, {
        style: 'currency',
        currency: currencyCode,
      }).format(amount);
    } catch (error) {
      console.warn('Free shipping money formatting failed', error);
      return amount.toFixed(2);
    }
  }

  decodeHtmlEntities(value) {
    const parserElement = document.createElement('textarea');
    parserElement.innerHTML = value;
    return parserElement.value;
  }
}

new FreeShippingProgress();
